// Weitere Übersetzungen [Suomi, English]: Meldungen des Servers und Texte des Feinschliffs.
// Eigene Datei, damit i18n.ts nicht weiter wächst.
export const MORE: Record<string, [string, string]> = {
  // Meldungen des Servers (kommen auf Deutsch, werden hier nachgeschlagen)
  'Ungültige Stellung (FEN)': ['Virheellinen asema (FEN)', 'Invalid position (FEN)'],
  'Höchstens 16 Figuren je Seite': ['Enintään 16 nappulaa kummallakin puolella', 'At most 16 pieces per side'],
  'Stellung nach den Regeln nicht möglich': ['Asema ei ole sääntöjen mukaan mahdollinen', 'Position is not possible under the rules'],
  'In der Demo nicht verfügbar': ['Ei käytettävissä demossa', 'Not available in the demo'],
  'Stockfish nicht gefunden': ['Stockfishia ei löytynyt', 'Stockfish not found'],
  'Stockfish antwortet nicht': ['Stockfish ei vastaa', 'Stockfish is not responding'],
  'Bildformat nicht lesbar': ['Kuvamuotoa ei voi lukea', 'Image format not readable'],
  'Rahmen liegt nicht im Bild': ['Kehys ei ole kuvan sisällä', 'The frame is outside the image'],
  'Kein Bild übergeben': ['Kuvaa ei annettu', 'No image provided'],
  'Bild zu groß (höchstens 8000 Pixel Kantenlänge)': ['Kuva on liian suuri (enintään 8000 pikseliä sivua kohden)', 'Image too large (at most 8000 pixels per side)'],
  // Figurennamen (Beschriftungen für Screenreader)
  'König': ['kuningas', 'king'],
  'Dame': ['kuningatar', 'queen'],
  'Turm': ['torni', 'rook'],
  'Läufer': ['lähetti', 'bishop'],
  'Springer': ['ratsu', 'knight'],
  'Bauer': ['sotilas', 'pawn'],
  '{c} {r} setzen': ['Aseta: {c} {r}', 'Place {c} {r}'],
};
